/* ============
 * State of the module setting
 * ============
 *
 * The initial state of the account module.
 */

export default {
  stickyHeader: true,
  stickyAside: true,
  foldedAside: true,
  hideAside: false,
  bgColor: true, // bg-dark on default
  releaseStatuses: {},
  releaseStatusesLastUpdated: null,
  isContentLoader: false,
  redirectTo: {
    name: null,
    params: {},
  },
};
